import { AccountInfo, InteractionType } from '@azure/msal-browser'
import { MsalAuthenticationTemplate, useMsal } from '@azure/msal-react'
import Backdrop from '@mui/material/Backdrop'
import Box from '@mui/material/Box'
import CssBaseline from '@mui/material/CssBaseline'
import React, {
  lazy,
  ReactNode,
  Suspense,
  useEffect,
  useRef,
  useState,
} from 'react'
import { HelpPage } from 'src/pages/HelpPage'

import { loginRequest } from '../lib/msalInstance'
import { Bars } from './Home/Bars'
import { LoadingSpinner } from './Shared/LoadingSpinner'

// Lazy so the modal registry (and the plan-entry forms it reaches) stays out
// of the render-blocking bundle; its chunk loads right after first paint.
const ModalHolder = lazy(() => import('./Modals/ModalHolder'))

const authRequest = {
  ...loginRequest,
}

export const Loading = () => {
  return (
    <Backdrop
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
      open={true}
    >
      <LoadingSpinner loadingText={''} />
    </Backdrop>
  )
}

export const Layout: React.FC<{ children: ReactNode }> = ({ children }) => {
  const accountRef = useRef<AccountInfo | null>(null)
  const { accounts } = useMsal()

  const [renderChildren, setRenderChildren] = useState<ReactNode | null>(null)

  useEffect(() => {
    const account = accounts[0]
    if (account) {
      accountRef.current = account
      setRenderChildren(children)
    } else {
      setRenderChildren(null)
    }
  }, [accounts, children])

  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      errorComponent={HelpPage}
      loadingComponent={Loading}
      authenticationRequest={authRequest}
    >
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <Bars />
        {renderChildren}
        <Suspense fallback={null}>
          <ModalHolder />
        </Suspense>
      </Box>
    </MsalAuthenticationTemplate>
  )
}
